import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomButton from 'components/CustomInput/Button';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import api from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';
import { CREATE_AMENDMENT_FORM } from 'store/key';
import { useDispatch } from 'react-redux';
import { compareEmail } from 'utility/general';

const AmendmentSelectModal = ({ isShow = false, siteResponseList, onCancel = () => null, row }) => {
    const [site, setSite] = useState('');
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);
    const [isValid, setValid] = useState(false);
    const userDetail = useSelector((state) => state.user.detail);
    const dispatch = useDispatch();
    const history = useHistory();

    // stage includes select, exist, create
    const [stage, setStage] = useState('select');

    const [choices, setChoices] = useState([]);

    const [existFormId, setExistFormId] = useState(0);

    useEffect(() => {
        setChoices(getChoices());

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getTitle = () => {
        if (stage === 'select') {
            return 'Which part of initial application would like to amend?';
        } else if (stage === 'exist') {
            return 'Existing amendment form found';
        } else if (stage === 'create') {
            return 'Confirm';
        }
    };

    const getContent = () => {
        if (stage === 'select') {
            return (
                <CustomOutlineSelect
                    value={site}
                    onChange={(e) => {
                        const { value } = e.target;
                        setSite(value);
                    }}
                    label={'Choose one'}
                    choices={choices}
                    placeholder={'Please choose your decision'}
                    isRequired
                    forceErrorDisplay={forceErrorDisplay}
                    isValidValue={(isValid) => setValid(isValid)}
                />
            );
        } else if (stage === 'exist') {
            return 'Do you want to redirect to the existing amendment form?';
        } else if (stage === 'create') {
            return 'Are you sure to create the application amendment form before amendment?';
        }
    };

    const handleOk = () => {
        if (!isValid) {
            return setForceErrorDisplay(true);
        }

        const [type, typeId] = site.split('-');

        setGlobalLoading(true);

        api.amendment
            .checkAmendmentExist(type, typeId)
            .then(async (res) => {
                if (res?.errorMessage) {
                    throw new Error(res.errorMessage);
                }

                const { exist, id } = res.data.result;

                if (exist) {
                    setStage('exist');
                    setExistFormId(id);
                } else {
                    setStage('create');
                }
            })
            .catch((error) => {
                console.error('Error:', error.message);
                // Optionally, handle the error (e.g., show a notification or dialog)
            })
            .finally(() => {
                setGlobalLoading(false);
            });
    };

    const getChoices = () => {
        const result = [];
        // if (row.ci.includes(userDetail.email)) {
        //     result.push({ key: `study-${row.id}`, display: 'Study Info', value: `study-${row.id}` });
        // }

        if (row.ci.some((item) => compareEmail(item, userDetail.email))) {
            result.push({ key: `study-${row.id}`, display: 'Study Info', value: `study-${row.id}` });
        }

        siteResponseList.forEach((item) => {
            const { code, id: siteId } = item;
            if (row.pi[code].some((item) => compareEmail(item, userDetail.email))) {
                result.push({ key: `site-${siteId}`, display: `Site (${code})`, value: `site-${siteId}` });
            }
        });

        return result;
    };

    return (
        <Dialog open={isShow} style={{ margin: 'auto' }}>
            <DialogTitle style={{ fontWeight: 'bold', width: 400 }}>
                <div style={{ fontSize: 16 }}>{getTitle()}</div>
            </DialogTitle>
            <DialogContent>{getContent()}</DialogContent>
            <DialogActions style={{ padding: 15 }}>
                <CustomButton type={'cancel'} onClick={onCancel} autoFocus>
                    Cancel
                </CustomButton>
                <CustomButton
                    onClick={() => {
                        if (stage === 'create') {
                            const [type, typeId] = site.split('-');
                            setGlobalLoading(true);

                            dispatch({
                                type: CREATE_AMENDMENT_FORM,
                                payload: {
                                    applicationFormId: row.id,
                                    amendmentType: type,
                                    amendId: typeId,
                                    callback: (createdId) => {
                                        history.push(
                                            `/post-approval-document/application-amendment-detail?id=${createdId}`,
                                        );
                                    },
                                    final: () => {
                                        setGlobalLoading(false);
                                    },
                                },
                            });

                            // history.push(
                            //     `/applications/create-application-amendment?id=${row.id}&type=${type}&typeId=${typeId}`,
                            // );
                        } else if (stage === 'exist') {
                            history.push(`/post-approval-document/application-amendment-detail?id=${existFormId}`);
                        } else if (stage === 'select') {
                            handleOk();
                        }
                    }}
                    autoFocus
                >
                    Confirm
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
};

export default AmendmentSelectModal;
